import React from 'react';
import PropTypes from 'prop-types';
import { ViewerPrimaryColorUserStyle } from '../../UserCustomization';

import './Transportation.css';

const TransportationComponent = ({ types, title, show }) => {
  const sortedProviders = [...types]
    .filter(type => (type.description && type.description !== '') || (type.name && type.name !== ''))
    .sort((a, b) => {
      if (a.name < b.name) return -1;
      if (a.name > b.name) return 1;
      return 0;
    });

  if (!show || sortedProviders.length === 0) {
    return null;
  }

  return (
    <div>
      <ViewerPrimaryColorUserStyle domStyle="color">
        <h3>{title}</h3>
      </ViewerPrimaryColorUserStyle>
      {
        sortedProviders
          .map((type, index) => (
            <div className="transportation-type" key={index}>
              {
                type.name &&
                <p>
                  <b>{type.name}</b>
                </p>
              }
              {type.description && <p>{type.description}</p>}
            </div>
        ))
      }
    </div>
  );
};

TransportationComponent.propTypes = {
  types: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    description: PropTypes.string,
  })),
  title: PropTypes.string,
  show: PropTypes.bool,
};

export default TransportationComponent;



// WEBPACK FOOTER //
// ./src/components/Areas/AreaDetails/Transportation.js